/**
 * New PDP only — mobile drawer menu lazy-load + submenu toggle fix.
 * Desktop header menus are handled by npp-mega-menu-fix.js.
 */
(function () {
  'use strict';

  var MOBILE_MAX = 1023;
  var fetching = false;
  var OPEND_CLASS = 'is--opend';

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function isNppPage() {
    return !!document.querySelector('.npp');
  }

  function drawerNeedsContent() {
    var drawer = document.getElementById('t4s-menu-drawer');
    if (!drawer) return false;

    if (drawer.querySelector('.t4s-skeleton-element, .t4s-loading--bg')) {
      return true;
    }

    var menuList = drawer.querySelector('#menu-mb__ul');
    if (menuList && menuList.querySelector('li, .t4s-menu-item')) {
      return false;
    }

    if (drawer.querySelector('#shopify-mb_nav') && !menuList) {
      return true;
    }

    return !drawer.querySelector('#menu-mb__ul, #menu-mb__cat');
  }

  function clearMobileMenuCache() {
    try {
      Object.keys(sessionStorage).forEach(function (key) {
        if (key.indexOf('timeMenuT4s') === 0 || key.indexOf('dataMenuT4s') === 0) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {
      /* ignore */
    }
  }

  function bindCloseButton(drawer) {
    var closeBtn = drawer.querySelector('#closeMenuBtn');
    if (!closeBtn || closeBtn.dataset.nppCloseBound === 'true') return;
    closeBtn.dataset.nppCloseBound = 'true';

    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var close = document.querySelector('[data-drawer-close]');
      if (close) {
        close.click();
      } else if (window.jQuery_T4NT) {
        jQuery_T4NT('[data-drawer-close]').trigger('click');
      }
    });
  }

  function toggleMobileSubmenu(menuItem) {
    if (!menuItem) return;

    var submenu = menuItem.querySelector(':scope > ul');
    if (!submenu) return;

    if (window.jQuery_T4NT) {
      var $item = jQuery_T4NT(menuItem);
      if ($item.hasClass(OPEND_CLASS)) {
        $item.removeClass(OPEND_CLASS).children('ul').slideUp(200);
      } else {
        $item.addClass(OPEND_CLASS).children('ul').slideDown(200);
      }
      return;
    }

    var isOpen = menuItem.classList.contains(OPEND_CLASS);
    if (isOpen) {
      menuItem.classList.remove(OPEND_CLASS);
      submenu.style.display = 'none';
    } else {
      menuItem.classList.add(OPEND_CLASS);
      submenu.style.display = 'block';
    }
  }

  function bindMobileSubmenuToggle(drawer) {
    if (!drawer || drawer.dataset.nppMbToggleBound === 'true') return;
    drawer.dataset.nppMbToggleBound = 'true';

    drawer.addEventListener('click', function (e) {
      if (!isMobile()) return;

      var icon = e.target.closest('.t4s-mb-nav__icon');
      var onlyIconFalseLink = e.target.closest('.t4s-menu-item-has-children.t4s-only_icon_false > a');
      var menuItem = null;

      if (icon) {
        menuItem = icon.closest('.t4s-menu-item-has-children');
      } else if (onlyIconFalseLink) {
        menuItem = onlyIconFalseLink.parentElement;
      }

      if (!menuItem || !drawer.contains(menuItem)) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      toggleMobileSubmenu(menuItem);
    }, true);
  }

  function parseMenuHtml(html) {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    var nav = wrapper.querySelector('#shopify-mb_nav');
    var cat = wrapper.querySelector('#shopify-mb_cat');
    var header = wrapper.querySelector('.t4s-drawer__header');

    return {
      headerHtml: header ? header.outerHTML : '',
      navHtml: nav ? nav.innerHTML : '',
      catHtml: cat ? cat.innerHTML : '',
      fullHtml: html
    };
  }

  function ensureDrawerShell(drawer, headerHtml) {
    if (!headerHtml || drawer.querySelector('.t4s-drawer__header')) return;

    drawer.insertAdjacentHTML('afterbegin', headerHtml);
  }

  function afterMenuInject(drawer) {
    bindCloseButton(drawer);
    bindMobileSubmenuToggle(drawer);

    if (window.jQuery_T4NT) {
      jQuery_T4NT(drawer).trigger('lazyincluded');
    }
  }

  function applyMobileMenuHtml(html) {
    var drawer = document.getElementById('t4s-menu-drawer');
    if (!drawer || !html || html === 'NVT_94') return false;

    if (html.indexOf('menu-mb__ul') === -1 && html.indexOf('menu-mb__cat') === -1) {
      return false;
    }

    var parts = parseMenuHtml(html);
    var navHost = drawer.querySelector('#shopify-mb_nav');
    var catHost = drawer.querySelector('#shopify-mb_cat');

    if (navHost && parts.navHtml) {
      ensureDrawerShell(drawer, parts.headerHtml);
      navHost.innerHTML = parts.navHtml;
      if (catHost && parts.catHtml) {
        catHost.innerHTML = parts.catHtml;
      }
    } else {
      drawer.innerHTML = parts.fullHtml;
    }

    afterMenuInject(drawer);
    return true;
  }

  function buildDrawerShell(navHtml, catHtml) {
    return (
      '<div class="t4s-drawer__header test25"><span>MENU</span>' +
      '<button type="button" class="t4s-close-btn" id="closeMenuBtn" aria-label="Close menu">✕</button></div>' +
      '<div data-tab-mb-content id="shopify-mb_nav" class="t4s-mb-tab__content is--active">' +
      (navHtml || '') +
      '</div>' +
      '<div data-tab-mb-content id="shopify-mb_cat" class="t4s-mb-tab__content">' +
      (catHtml || '') +
      '</div>'
    );
  }

  function fetchText(url) {
    if (window.T4SThemeSP && typeof T4SThemeSP.getToFetchSection === 'function') {
      return T4SThemeSP.getToFetchSection(null, 'text', url);
    }

    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      return res.text();
    });
  }

  function fetchSectionFallback() {
    return Promise.all([
      fetchText('/?section_id=mb_nav'),
      fetchText('/?section_id=mb_cat').catch(function () {
        return '';
      })
    ]).then(function (parts) {
      var navHtml = parts[0];
      if (!navHtml || navHtml === 'NVT_94' || navHtml.indexOf('menu-mb__ul') === -1) {
        return false;
      }
      return applyMobileMenuHtml(buildDrawerShell(navHtml, parts[1]));
    });
  }

  function fetchMobileMenu() {
    if (!drawerNeedsContent() || fetching) {
      return Promise.resolve();
    }

    fetching = true;
    clearMobileMenuCache();

    var searchUrl = (window.T4Sroutes && window.T4Sroutes.search_url) || '/search';
    var fetchUrl = searchUrl + '/?view=mn';

    function finish(html) {
      var loadCss = function () {
        if (
          window.T4SThemeSP &&
          T4SThemeSP.Helpers &&
          typeof T4SThemeSP.Helpers.promiseStylesheet === 'function' &&
          window.T4Sconfigs &&
          T4Sconfigs.stylesheet2
        ) {
          return T4SThemeSP.Helpers.promiseStylesheet(T4Sconfigs.stylesheet2);
        }
        return Promise.resolve();
      };

      return loadCss()
        .then(function () {
          if (applyMobileMenuHtml(html)) return true;
          return fetchSectionFallback();
        })
        .finally(function () {
          fetching = false;
        });
    }

    return fetchText(fetchUrl)
      .then(finish)
      .catch(function (err) {
        fetching = false;
        return fetchSectionFallback();
      });
  }

  function boot() {
    if (!isMobile() || !isNppPage()) return;

    var drawer = document.getElementById('t4s-menu-drawer');
    if (drawer) {
      bindMobileSubmenuToggle(drawer);
    }

    if (!drawerNeedsContent()) return;
    fetchMobileMenu().catch(function (err) {
      console.warn('[npp-mobile-menu-fix] mobile menu fetch failed', err);
    });
  }

  function bindDrawerOpen() {
    var drawer = document.getElementById('t4s-menu-drawer');
    if (!drawer) return;

    bindMobileSubmenuToggle(drawer);

    if (window.jQuery_T4NT) {
      jQuery_T4NT(drawer).on('opendDrawer', function () {
        if (isMobile() && isNppPage()) boot();
      });
    }

    document.querySelectorAll('[data-menu-drawer]').forEach(function (btn) {
      if (btn.dataset.nppDrawerBound === 'true') return;
      btn.dataset.nppDrawerBound = 'true';

      btn.addEventListener('click', function () {
        if (!isMobile() || !isNppPage()) return;
        window.setTimeout(boot, 50);
        window.setTimeout(boot, 400);
      });
    });

    var observer = new MutationObserver(function () {
      if (!isMobile() || !isNppPage() || !drawer.classList.contains('t4s-drawer--open')) return;
      bindMobileSubmenuToggle(drawer);
      if (drawerNeedsContent()) boot();
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  }

  function schedule() {
    if (!isMobile() || !isNppPage()) return;

    bindDrawerOpen();
    boot();
    window.setTimeout(boot, 800);
    window.setTimeout(boot, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();


